export const billingPeriod = {
  unit: {
    month: 'month',
    week: 'week',
    year: 'year',
    day: 'day',
  },
  singularUnits: {
    month: 'Monthly',
    week: 'Weekly',
    year: 'Yearly',
    day: 'Daily',
  },
  plural: 'Every {{interval}} {{unit}}',
  pluralUnits: {
    month: 'months',
    week: 'weeks',
    year: 'years',
    day: 'days',
  },
  singularPricePerUnit: '{{ price }} per {{ unit }}',
  pluralPricePerUnit: '{{ price }} every {{interval}} {{unit}}',
};
